import { render, staticRenderFns } from "./distributors.vue?vue&type=template&id=197fbd42&"
import script from "./distributors.vue?vue&type=script&lang=js&"
export * from "./distributors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports